__turbopack_context__.v({
  "desktopBuySectionInfo": "index-module__IxdvkW__desktopBuySectionInfo",
  "mobileBuySectionInfo": "index-module__IxdvkW__mobileBuySectionInfo",
});
